import { hasClass, findClosest } from 'utils/element';

const IMAGE_WRAPPER_CLASS_NAME = 'image-wrapper';
export const IMAGE_SRC_KEY = 'data-image-src';
export const IMAGE_ZOOM_DIV_ID = 'image-zoom';
export const IMAGE_ZOOM_DIV_ID_OLD_EDITOR = 'image-zoom-old-editor';

export default class ImageWrapper {
  private static addZoomContainer(imageWrapper: any, image: any, isOldEditor = false) {
    const imageZoomContainer = document.createElement('div');
    imageZoomContainer.setAttribute(IMAGE_SRC_KEY, image.getAttribute('src'));
    imageZoomContainer.id = isOldEditor ? IMAGE_ZOOM_DIV_ID_OLD_EDITOR : IMAGE_ZOOM_DIV_ID;
    imageWrapper.appendChild(imageZoomContainer);

    return true;
  }

  private static addNewImageWrapper(image: any, zoomButtonAdded: boolean) {
    const wrapper = document.createElement('figure');
    wrapper.classList.add(IMAGE_WRAPPER_CLASS_NAME);
    wrapper.style.float = image.style.cssFloat;
    if (
      image.parentElement &&
      image.parentElement.tagName.toLowerCase() === 'td' &&
      image.parentElement.style.width === ''
    ) {
      wrapper.style.marginLeft = 'auto';
      wrapper.style.marginRight = 'auto';
      wrapper.style.width = image.style.width;
      wrapper.style.height = image.style.height;
    }
    image.parentNode.insertBefore(wrapper, image);
    wrapper.appendChild(image);
    if (!zoomButtonAdded) {
      this.addZoomContainer(wrapper, image, true);
    }
  }

  static wrap(finder: any) {
    const images = finder.querySelectorAll('img');
    for (const image of images) {
      let zoomButtonAdded = false;
      const croppedImageWrapper = findClosest(image, '.cropped-image');
      if (croppedImageWrapper) {
        this.addZoomContainer(croppedImageWrapper, image);
        zoomButtonAdded = true;
        if (image.parentElement && hasClass(image.parentElement, IMAGE_WRAPPER_CLASS_NAME)) {
          return finder;
        }
      } else {
        const imageEditorWrapper = findClosest(image, '[data-content-type="ImageEditor"]');
        if (imageEditorWrapper) {
          this.addZoomContainer(imageEditorWrapper, image);
          zoomButtonAdded = true;
        }
      }

      this.addNewImageWrapper(image, zoomButtonAdded);
    }
  }
}
